<template>
  <div aria-hidden="true" class="fixed inset-0 pointer-events-none">
    <div
      class="absolute inset-0 opacity-[0.75]"
      :style="{
        background: `
          radial-gradient(1100px 500px at 15% -10%, rgba(255,140,184,0.18), rgba(255,255,255,0) 60%),
          radial-gradient(900px 480px at 95% 0%, rgba(98,169,255,0.16), rgba(255,255,255,0) 58%),
          radial-gradient(700px 380px at 40% 115%, rgba(255,219,133,0.18), rgba(255,255,255,0) 62%)
        `
      }"
    ></div>
    <div
      class="absolute inset-0 mix-blend-multiply opacity-[0.06]"
      :style="{
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'400\\' height=\\'400\\'><filter id=\\'n\\'><feTurbulence type=\\'fractalNoise\\' baseFrequency=\\'0.8\\' numOctaves=\\'4\\'/><feColorMatrix type=\\'saturate\\' values=\\'0\\'/><feComponentTransfer><feFuncA type=\\'table\\' tableValues=\\'0 0.6\\'/></feComponentTransfer></filter><rect width=\\'100%\\' height=\\'100%\\' filter=\\'url(%23n)\\' opacity=\\'0.6\\' fill=\\'#000\\'/></svg>')`,
        backgroundSize: '300px 300px'
      }"
    ></div>
    <div
      class="absolute inset-0 pointer-events-none"
      style="background: radial-gradient(80% 50% at 50% 50%, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) 90%);"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'BackgroundTextures'
}
</script>

